<template>
  <v-container id="date-picker" class="pt-0 px-0 pb-0">
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="date"
      transition="scale-transition"
      offset-y
      min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          hide-details='auto'
          :rules="rules"
          clearable
          class="pt-0"
          v-model="show"
          :label="label"
          readonly
          v-bind="$attrs"
          v-on="on"
          @click:clear='dateClear'
        >
      </v-text-field>
      </template>
      <v-date-picker v-model="date" hide-details='auto' locale="zh-cn" v-bind='$attrs' :range="range" :multiple='multiple' no-title scrollable class="pt-0">
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="menu = false">取消</v-btn>
        <v-btn text color="primary" @click="change">确定</v-btn>
      </v-date-picker>
    </v-menu>
  </v-container>
</template>

<script>
  export default {
    name: 'MaterialDate',
    props: {
      value: {
        type: [String, Array],
        default: ''
      },
      range: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: '时间选择'
      },
      rules: {
        type: Array
      }
    },
    data () {
      return {
        date: this.value,
        menu: false
      }
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set() {}
      }
    },
    methods: {
      change () {
        this.$refs.menu.save(this.date)
        if (this.date instanceof Array) {
          const this_ = this
          this.date.sort((a, b) => (this_.$moment(a).valueOf() > this_.$moment(b).valueOf() ? 1 : -1))
        }
        this.$emit('input', this.date)
        this.$emit('on-change', this.date)
      },
      dateClear () {
        this.date = this.value instanceof Array ? [] : ''
        this.$emit('input', this.date)
        this.$emit('on-change', this.date)
      }
    }
  }
</script>
